/**
 * React Query hook for the Integration-Agent import history (#1936).
 */
import { useQuery } from '@tanstack/react-query';
import { integrationAgentService } from '../services/integrationAgentService';

export const integrationAgentImportKeys = {
  all: ['integrationAgentImports'] as const,
  list: (source: string) => [...integrationAgentImportKeys.all, source] as const,
};

/**
 * Fetch the observed-imports history for a source. No server cache — the
 * aggregate is cheap (≤ 1 list + ≤ max_years doc-entity reads); a client-side
 * `staleTime` keeps re-navigations snappy without staleness surprises.
 */
export function useIntegrationAgentImports(source: string = 'myfarm24') {
  return useQuery({
    queryKey: integrationAgentImportKeys.list(source),
    queryFn: () => integrationAgentService.listImports(source),
    staleTime: 60_000,
  });
}
